import { useEffect, useState, useTransition, ReactNode } from "react"
import SlideTransition from "./Transition"
import { ProgressBarTop } from "@/components/feedback/ProgressBarLoader"

interface DelayedRenderProps {
  children: ReactNode
  enabled?: boolean
  fallback?: ReactNode // Permite passar um componente de loading
}

const DelayedRender: React.FC<DelayedRenderProps> = ({ children, fallback = null, enabled = true, ...props }) => {
  const [isMounted, setIsMounted] = useState(false)
  const [isPending, startTransition] = useTransition()

  useEffect(() => {
    startTransition(() => {
      setIsMounted(true)
    })
  }, [])

  if (enabled === false) {
    return <>{children}</>
  }

  // Se ainda estiver carregando, exibe o fallback
  if (!isMounted || isPending) {
    // return <>{fallback || <LoadingBarTop loading delay={0} />}</>
    return <>{fallback || <ProgressBarTop />}</>
  }

  return (
    <>
      <SlideTransition variant="fade-in">{children}</SlideTransition>
    </>
  )
}

export default DelayedRender
